import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import styled from "styled-components";

const basePath = window.location.pathname.includes("/minecraft.dev") ? "/minecraft.dev" : "";

const cursor = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 20px;
    height: 20px; 
    // background-color: rgba(255, 0, 100, 0.8);
    border-radius: 50%;
    pointer-events: none;
    z-index: 9999;
    mix-blend-mode: difference;
    // transition: transform 0.1s ease;
    background: url(../${basePath}/img/cursor.svg);
  
  @media (max-width: 768px) {
    .cursor {
      width: 10px;
      height: 10px;
    }
  `;


const AnimatedCursor = () => {
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [isDown, setisDown] = useState(false);

    useEffect(() => {
        const moveCursor = (e) => {
            let x, y;
            if (e.type.includes('touch')) {
                x = e.touches[0].clientX;
                y = e.touches[0].clientY;
            } else {
                x = e.clientX;
                y = e.clientY;
            }
            setPosition({ x, y });
        };
        const downCursor = (e) => {
            setisDown(true);
        };
        const upCursor = (e) => {
            setisDown(false);
        };

        window.addEventListener('mousemove', moveCursor);
        window.addEventListener('touchmove', moveCursor);
        window.addEventListener('mousedown', downCursor);
        window.addEventListener('mouseup', upCursor);

        return () => {
            window.removeEventListener('mousemove', moveCursor);
            window.removeEventListener('touchmove', moveCursor);
            window.removeEventListener('mousedown', downCursor);
            window.removeEventListener('mouseup', upCursor);
        };
    }, []);

    return (
        <>
        <motion.div
            className="cursor"
            style={{ x: position.x - 20, y: position.y -20, duration: 0 }}
            transition={{ _type: 'ease', _stiffness: 1000, _damping: 20 }}
        >
        </motion.div>
        <motion.div
        className="cursor2"
        style={{ x: position.x-44, y: position.y-38, display: !isDown ? 'none' : 'block' }}
        transition={{ _type: 'ease', _stiffness: 1000, _damping: 20 }}
    >
            <img src={`${basePath}/img/cursor2.svg`} />
            </motion.div>
            </>
    );
};

export default AnimatedCursor;
